module.exports = __webpack_public_path__ + "static/media/shower.6fe0dbfe.svg";